<template>
  <div>
      <v-data-table :items="documentos" :headers="colunas" :total-items="totalItens"
                    class="az-table-list tabela-documentos elevation-1" :pagination.sync="paginacaoInterna"
                    no-data-text="Nenhum documento foi encontrado.">
            <template v-slot:headers="props">
              <tr>
                <th style="padding: 0 !important;">
                  <v-tooltip top>
                  <v-checkbox class="single-checkbox" slot="activator"
                      :input-value="selecionouTodosDocs"
                      :indeterminate="selecionouAlgumDoc && !selecionouTodosDocs"
                      :disabled="documentos.length === 0"
                      hide-details color="light-blue darken-2"
                      @click.stop="selecionarTodosDocs"/>
                    <span v-show="!selecionouTodosDocs">Selecionar todos</span>
                    <span v-show="selecionouTodosDocs">Remover seleção</span>
                  </v-tooltip>
                </th>
                <th v-for="header in props.headers" :key="header.text" :class="header.class" align="left"
                    :style="`${header.style}; ${header.width? 'width: ' + header.width : ''}`">
<!--                    @click="changeSort(header.value)"-->
<!--                    :class="['column sortable', paginacao.descending ? 'desc' : 'asc', header.value === paginacao.sortBy ? 'active' : '']"-->
<!--                  <v-icon style="color: gray !important; opacity: 1" small>arrow_upward</v-icon>-->
                  <strong>{{ header.text }}</strong>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
                <tr class="linhas-tabela-docs" style="height: 50px;" :id="props.item.documentoVirtualizadoId">
                  <td style="padding: 0 !important;">
                    <v-checkbox primary hide-details
                                color="light-blue darken-2" class="single-checkbox"
                                :input-value="foiSelecionado(props.item.documentoVirtualizadoId)"
                                @click.stop="selecionarDoc(props.item.documentoVirtualizadoId)"/>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.lote" style="font-size: 14px;">
                      {{props.item.lote}}
                    </span>
                    <span v-show="!props.item.lote" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.nome" style="font-size: 14px;">
                      {{props.item.nome}}
                    </span>
                    <span v-show="!props.item.nome" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.tipo" style="font-size: 14px;">
                      {{ props.item.tipo | azEnum(tiposDocumentoVirtualizados) }}
                    </span>
                    <span v-show="!props.item.tipo" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.virtualizacao" style="font-size: 14px;">
                      {{props.item.virtualizacao | az-date('DD/MM/YYYY HH:mm:ss')}}
                    </span>
                    <span v-show="!props.item.virtualizacao" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.fase" style="font-size: 14px;">
                      <span v-if="novasAbasAtivas">
                        {{props.item.fase | novasAbasFase}}
                      </span>
                      <span v-else>
                        {{props.item.fase}}
                      </span>
                    </span>
                    <span v-show="!props.item.fase" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.fornecedor" style="font-size: 14px;">
                      {{props.item.fornecedor}}
                    </span>
                    <span v-show="!props.item.fornecedor" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left">
                    <v-tooltip top>
                      <div slot="activator">
                        <v-icon size="20" style="vertical-align: bottom">person</v-icon>
                        <span v-show="props.item" style="font-size: 14px; height: 20px">
                        {{props.item.assinaturas ? props.item.assinaturas.length :'0'}}
                        </span>
                      </div>
                      <span v-if="props.item.assinaturas && props.item.assinaturas.length > 0">
                        <strong class="mr-2" style="color: #1565c0">Assinado por:</strong> <br>
                        <span class="pl-2" v-for="pessoa in props.item.assinaturas">
                          {{ pessoa.nomeSignatario }} <br>
                        </span>
                      </span>
                      <strong style="color: #1565c0" v-else>
                        Não assinado!
                      </strong>
                    </v-tooltip>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.situacaoDocumento" style="font-size: 14px;">
                      {{ props.item.situacaoDocumento | azEnum(situacoesDocumentosVirtualizados) }}
                    </span>
                    <span v-show="!props.item.situacaoDocumento" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding: 5px">
                    <span style="display: flex;" class="justify-center">
                       <v-tooltip top v-if="props.item.situacaoEdocs == 'AGUARDANDO'">
                        <span slot="activator">
                          <v-icon color="orange" size="20">mdi-alert-circle</v-icon>
                        </span>
                         Aguardando processamento para envio ao E-docs
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoEdocs == 'SINCRONIZADO'">
                        <span slot="activator">
                          <v-icon color="green" size="20">mdi-check-circle</v-icon>
                        </span>
                         Enviado ao E-docs
                      </v-tooltip>
                      <v-tooltip top>
                        <span slot="activator">
                          <v-icon  size="20" @click="baixar(props.item)">download</v-icon>
                        </span>
                        Baixar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.juntado && !props.item.ehTermoDesentranhamento && props.item.situacaoEdocs == null">
                        <span slot="activator">
                          <v-icon size="20" @click="desentranhar(props.item)">remove_circle</v-icon>
                        </span>
                        Desentranhar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.juntado && !props.item.ehTermoDesentranhamento && props.item.situacaoEdocs == null">
                        <span slot="activator">
                          <v-icon size="20" @click="reordenar(props.item)" class="rotacao-90">sync_alt</v-icon>
                        </span>
                        Reordenar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.juntado && !props.item.cancelado  && props.item.situacaoEdocs == null">
                        <span slot="activator">
                          <v-icon size="20" @click="cancelar(props.item)">block</v-icon>
                        </span>
                        Cancelar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="!props.item.juntado">
                        <a slot="activator" @click="assinar(props.item)" class="px-1">
                          <icone-assinar-documento/>
                        </a>
                        Assinar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="!props.item.juntado">
                        <a slot="activator" @click="juntar(props.item)" class="px-1">
                          <icone-juntar-documento/>
                        </a>
                        Juntar Documento
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
            </template>
        </v-data-table>
  </div>
</template>

<script>
import {situacoesDocumentosVirtualizados, tiposDocumentoVirtualizados} from '@/commons/constants'
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento";
import IconeJuntarDocumento from "@/commons/components/icones/IconeJuntarDocumento";
import {mapState} from "vuex";
export default {
  name: 'painelDocumentosTabela',
  components: {IconeJuntarDocumento, IconeAssinarDocumento},
  props:{
        documentos: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        paginacao: {
            type: Object,
            required: true,
        },
        totalItens: {
            type: Number,
            required: true,
        }
    },
    data(){
      return {
        situacoesDocumentosVirtualizados,
        tiposDocumentoVirtualizados,
        colunas: [
          {
            text: 'Tipo/Item',
            value: 'tipo',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Documento',
            value: 'nome',
            sortable: true,
            class: 'primary--text',
          },
          {
            text: 'Tipo',
            value: 'tipo',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Virtualização',
            value: 'virtualizacao',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Fase',
            value: 'fase',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Fornecedor',
            value: 'fornecedor',
            sortable: true,
            class: 'primary--text',
            width: '150px'
          },
          {
            text: 'Signatários',
            value: 'signatarios',
            sortable: false,
            class: 'primary--text'
          },
          {
            text: 'Situação',
            value: 'situacaoDocumento',
            sortable: true,
            class: 'primary--text',
            width: '100px'
          },
          {
            text: 'Ações',
            sortable: false,
            class: 'primary--text px-1',
            style: 'text-align: center'
          },
        ],
        paginacaoInterna: this.paginacao,
        selecionados: []
      }
    },
    computed: {
      ...mapState(['parametros']),
      novasAbasAtivas(){
        return this.parametros.parametro.ativarNovasAbas || false
      },
      selecionouTodosDocs() {
        const quantidadeLotesSelecionados = this.selecionados.length
        if(this.paginacao.rowsPerPage > 0) {
          return quantidadeLotesSelecionados > 0 && quantidadeLotesSelecionados === this.paginacao.rowsPerPage
        } else {
          return quantidadeLotesSelecionados > 0 && quantidadeLotesSelecionados === this.totalItens
        }
      },
      selecionouAlgumDoc() {
        return this.selecionados.length > 0
      },
    },
    methods: {
      foiSelecionado(id){
        return this.selecionados.includes(id)
      },
      selecionarDoc(idCheckbox){
        if(this.foiSelecionado(idCheckbox)){
          this.selecionados = this.selecionados.filter(id => id !== idCheckbox)
        }else{
          this.selecionados.push(idCheckbox)
        }
      },
      selecionarTodosDocs(){
        const itens = [...document.getElementsByClassName('linhas-tabela-docs')].map(item => item.id)
        this.$nextTick(() => {
          if (this.selecionouTodosDocs) {
            this.selecionados = []
          } else {
            this.selecionados = itens
          }
        })
      },
      changeSort (column) {
        if (this.paginacao.sortBy === column) {
          this.paginacao.descending = !this.paginacao.descending
        } else {
          this.paginacao.sortBy = column
          this.paginacao.descending = false
        }
      },
      baixar(doc){
        this.$emit('baixar', doc)
      },
      desentranhar(doc){
        this.$emit('desentranhar', doc)
      },
      reordenar(doc){
        this.$emit('reordenar', doc)
      },
      cancelar(doc){
        this.$emit('cancelar', doc)
      },
      assinar(doc){
        this.$emit('assinar', doc)
      },
      juntar(doc){
        this.$emit('juntar', doc)
      }
    },
    watch: {
      paginacaoInterna: {
        handler(novoValor) {
          this.$emit('paginar', novoValor)
          this.selecionados = [];
        },
        deep: true
      }
    },
    filters:{
      novasAbasFase(value){
        if(!value) return ''
        if(value === 'AGUARDANDO ABERTURA'){
          return 'PROPOSTAS'
        }
        if(value === 'ABERTURA DE VISTAS'){
          return 'JULGAMENTO'
        }
        return value
      }
    }
}
</script>

<style lang="stylus">
  .tabela-documentos
      padding 16px

      tr
        border 0

      tr:last-child
        border-bottom 0 !important

      thead tr th
        padding 5px 10px !important
        font-weight bold

      thead tr th:first-child
        padding 0 24px !important

      .v-datatable__expand-col
        border-bottom 1px solid #ddd
        padding-top 0 !important

  .single-checkbox
    .v-input__slot
      border 0 !important

  .rotacao-90
    -webkit-transform rotate(90deg)
    -moz-transform rotate(80deg)
    -o-transform rotate(90deg)
    -ms-transform rotate(90deg)
    transform rotate(90deg)

  i
    font-size 20px

  .v-tooltip__content
      background-color white !important
      color black !important

    @keyframes myfirst{
      0% {background-color: white;}
      50% {background-color: #ff7c8a;}
      100% {background-color: white;}
    }

    @-webkit-keyframes myfirst{
      0%      {background-color:white;}
      50%     {background-color: #ff7c8a;}
      100%    {background-color:white;}
    }

  .transicionar-destacado
    -webkit-animation-name myfirst
    -webkit-animation-duration 1s
    -webkit-animation-timing-function ease-in-out
    -webkit-animation-play-state running

    animation-name myfirst
    animation-duration 1s
    animation-timing-function ease-in-out
    animation-play-state running
    background-color: white

  .linhas-tabela-docs
    scroll-margin-top: 100px;
</style>
